<template>
  <!-- 音频分类 -->
  <div class="dataset-audio-categorization">
    <classification></classification>
    <div class="main">
      <!-- <div class="dataset-get">
        <div class="select-tool">
          <span class="label">
            <i class="required">*</i>
            选择数据集：
          </span>
          <el-select
            class="select-box"
            v-model="activeDataset"
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div> -->

      <!-- 选定数据集后显示 -->
      <!-- <div class="bnts-tag" v-show="activeDataset">
        <button class="btn-primary">标签筛选</button>

        <button
          class="btn-add-tag"
          title="添加标签"
          @click="activeAddTagPopup"
        ></button>

        <el-button
          type="primary"
          class="quote-upload btn-primary"
          @click="quoteDataset"
          v-show="activeDataset && activeLabel"
        >引用数据集</el-button>
        <el-button
          type="primary"
          class="btn-upload btn-primary"
          @click="uploadPictures"
          v-show="activeDataset && activeLabel"
        >
          上传音频
        </el-button>
        <el-alert title="* 每个标签的音频不少于20个" type="error"> </el-alert>
      </div> -->
      <!-- 有音频数据显示 -->
      <!-- 音频累计 -->
      <!-- <span class="dataset-pic-total" v-show="Pictures.total">
        {{ '累计' + Pictures.total + '个音频' }}
      </span> -->
      <!-- <div class="group-tag">
        <a
          href="javascript:void(0);"
          v-for="(item, idx) in Label.records"
          :class="['h-tag', activeLabel === item.labelId ? 'active' : '']"
          @click="activeCatetoryLabel(item.labelId, idx)"
          :key="idx"
        >
          <span>{{ item.labelName }}</span>
          <i class="btn-edit el-icon-edit-outline" @click.stop="activeRenameLabelPopup(item.labelName, item.labelId, idx)"></i>
          <i class="btn-del el-icon-close" @click.stop="activeLabelDeletePopup(item.labelId, item.datasetId, idx)"></i>
        </a>
      </div> -->

      <div class="picture-box">
        <!-- <ul class="pictures">
          <li
            class="picture-item"
            v-for="(pic, idx) in Pictures.records"
            :key="idx"
          >
            <i class="icon-caret-preview" @click="onFilePreview(pic.audioUrl)"></i>
            <figure>
              <img src="../../assets/images/audioImage@2x.png" alt="pic.audioName" />
            </figure>
            <div class="btns">
              <button
                class="btn-delete"
                @click="activeDeletePopup(pic.audioId, idx)"
              >
                删除
              </button>
              <button
                class="btn-primary"
                @click="activeRenamePopup(pic, idx)"
              >
                重命名
              </button>
            </div>
            <div class="title ellipsis" :title="pic.audioName">
              {{ pic.audioName }}
            </div>
          </li>
        </ul> -->
        <!-- 分页 -->
        <!-- <div class="pagination">
          <el-pagination
            @current-change="handleCurrentChange"
            background
            :current-page.sync="pagination.currentPage"
            :page-size="pagination.pageSize"
            :pager-count="pagination.pagerCount"
            layout="slot, prev, pager, next"
            :total="pagination.totalCount"
            :hide-on-single-page="true"
          >
          </el-pagination>
        </div> -->
      </div>
    </div>
    <!-- 弹窗集 -->
    <div class="popup-list">
      <!-- 删除 -->
      <!-- <gat-popup
        :class="[
          'popup-delete popup-delete-2',
          popupActive === 'delete' || popupActive === 'label_delete'
            ? 'on'
            : 'off',
        ]"
        :title="popupActive === 'delete'?'删除音频':'删除标签'"
        :primary-button="'删除'"
        @cancel="cancelPopup"
        @confirm="deleteOperate"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span v-show="popupActive === 'label_delete'" class="title"
                >确定删除此分类及全部音频吗？</span
              >
              <span v-show="popupActive === 'delete'" class="title"
                >确定删除此音频吗？</span
              >
            </div>
          </div>
        </template>
      </gat-popup> -->
      <!-- 重命名 -->
      <!-- <gat-popup
        :class="['popup-rename', popupActive === 'rename' ? 'on' : 'off']"
        :title="'重命名'"
        @cancel="cancelPopup"
        @confirm="renameOperate"
      >
        <template v-slot:content>
          <el-input placeholder="请输入重命名" v-model.trim="popupData.rename.value" maxlength="20" show-word-limit />
        </template>
      </gat-popup> -->
      <!-- 添加新标签 -->
      <!-- <gat-popup
        :class="['popup-add-tag', popupActive === 'add_tag' ? 'on' : 'off']"
        :title="'添加分类'"
        @cancel="cancelPopup"
        @confirm="addLabel"
      >
        <template v-slot:content>
          <div v-if="Label.records&&Label.records.length >= 15">
            <p class="p-tip">
              单个数据集的分类标签数最多不超过15个哦~
            </p>
            <div class="button-row">
              <el-button type="primary" @click="cancelPopup">我知道了</el-button>
            </div>
          </div>
          <div v-else>
            <el-input placeholder="新的分类命名" v-model.trim="popupData.labelName" maxlength="20" show-word-limit />
            <p class="tip-list">
              <i class="required">*</i>单个数据集的分类标签数最多不超过15个。
            </p>
          </div>
        </template>
      </gat-popup> -->
      
      <!-- <model-training-upload-tips
        :modelType="modelType"
        :popupActive="popupActive"
        @confirmUploadTip="confirmUploadTip"
        @cancelPopup="cancelPopup"
        @uploadNoTipChange="uploadNoTipChange"
      ></model-training-upload-tips>
      
      <file-preview
        :modelType="modelType"
        :fileUrl="currentAudioUrl"
        :dialogvisibleview="dialogvisibleview"
        @onClickDialog="dialogvisibleview = false"
      ></file-preview>
      
      <dataset-popup
        :modelType="modelType"
        :modelDatasetId="activeDataset"
        :modelLabelId="activeLabel"
        :fileNumAll="Pictures.total"
        :drawerShow="drawerShow"
        @onDrawerShow="drawerShow = false"
        @getPictureList="getPictureList"
      ></dataset-popup> -->
    </div>
  </div>
</template>

<script>
// import GatPopup from '@/components/common/GatPopup'
// import IconInfoHelp from '@/components/icons/typography/InfoHelp'
// import PRETRAIN from '@/axios/pretrain/pretrain.js'
// import COMMON from '@/axios/common/common.js'

// import ModelTrainingUploadTips from '@/components/pretrain/ModelTrainingUploadTips.vue'
// import FilePreview from '@/components/pretrain/FilePreview.vue'
// import DatasetPopup from '@/components/pretrain/DatasetPopup.vue'

import Classification from '@/components/pretrain/Classification.vue'

export default {
  name: 'dataset-audio-categorization',
  components: { Classification },
  mixins: [],
  props: [],
  data() {
    return {
      // photoBaseUrl: window.gtaAiConfig.photoDomain, // 资源平台上传基地址
      // currentAudioUrl: '', // 当前音频路径
      // dialogvisibleview: false,
      // selectCondition: 0,
      // checkList: ['1'],
      // checkArr: [],
      // // checked: null,
      // classifyParameterList: [],
      // DatasetList: [],
      // Label: {
      //   records: [],
      //   current: 1,
      //   pageSize: 30,
      //   total: 0,
      // },
      // ClassifyData: {},
      // Pictures: {
      //   records: [],
      //   size: 20,
      //   current: 1,
      //   total: 0,
      // },
      // activeDataset: '',
      // activeLabel: null,
      // // 翻页
      // pagination: {
      //   currentPage: 1,
      //   pageSize: 20,
      //   totalCount: 0,
      //   pagerCount: 5,
      // },
      // // 弹窗
      // popupActive: '',
      // popupData: {
      //   pictureId: '',
      //   pictureName: '',
      //   rename: {
      //     index: -1,
      //     audioName: '',
      //     value: '',
      //   },
      //   uploadNoTip: false,
      //   labelName: '',
      //   delete: {
      //     index: -1,
      //   },
      //   labelDelete: {
      //     index: -1,
      //     labelId: '',
      //     datasetId: '',
      //   },
      // },
      // Placeholder: {
      //   picture02: require('../../../public/images/pretrain/placeholder-picture-02.png'),
      // },
      // errorCount: 0, // 错误计数
      // Icons: {
      //   InfoHelp: {
      //     iconName: '',
      //     viewBox: '0 0 36 36',
      //     width: '36',
      //     height: '36',
      //     // iconColor: "#fff"
      //   },
      // },
      // formdata: null,
      // dataview: '',
      // fullscreenLoading: null, // 加载效果
      // wavesAudio: null, // 音频实例
      // speed: 1,
      // drawerShow: false, // 引用数据集弹窗
    }
  },
  computed: {
    // options() {
    //   if (!this.DatasetList) {
    //     return []
    //   }

    //   return this.DatasetList.map((item) => {
    //     return { value: item.datasetId, label: item.datasetName }
    //   })
    // },
    // token() {
    //   return this.$store.state.token
    // },
    // modelType() {
    //   return this.$route.params.modeltype
    // },
  },
  watch: {
    // token() {
    //   this.getDatasetPageList()
    // },
    // activeDataset() {
    //   // 重新初始化
    //   this.Pictures = {
    //     records: [],
    //     size: 20,
    //     current: 1,
    //     total: 0,
    //   }

    //   this.activeLabel = null

    //   this.getLabelList().then(() => {
    //     this.getPictureList()
    //   })
    // },
    // activeLabel() {
    //   this.getPictureList()
    // },
    // Pictures(pictures) {
    //   Object.assign(this.pagination, {
    //     currentPage: pictures.current,
    //     size: pictures.size,
    //     totalCount: pictures.total,
    //   })
    // },
  },
  created () {},
  mounted() {
    // this.localStorageUploadTip()

    // if (this.$route.query.datasetId) {
    //   this.activeDataset = this.$route.query.datasetId; // 获取数据集详情返回模型id
    // }
    // if (this.$route.params.datasetId) {
    //   this.activeDataset = this.$route.params.datasetId
    // }

    // if (this.token) {
    //   this.getDatasetPageList().then(() => {
    //     if (this.activeDataset) {
    //       this.getLabelList().then(() => {
    //         this.getPictureList()
    //       })
    //     }
    //   })
    // }

  },
  methods: {
    // onFilePreview(url) {
    //   this.currentAudioUrl = this.photoBaseUrl + url
    //   this.dialogvisibleview = true
    // },
    // // 获取数据集列表
    // getDatasetPageList() {
    //   let data = {
    //     type: this.modelType
    //   };

    //   return new Promise((resolve, reject) => {
    //     PRETRAIN.selectDataset(data).then(result => {
    //       if (result.isSuccess) {
    //         this.DatasetList = result.data;
    //         resolve(result.data);
    //       } else {
    //         reject(result);
    //       }
    //     });
    //   });
    // },
    // // 标签处理，标签最多 20 个
    // // Label
    // getLabelList() {
    //   var datasetId = this.activeDataset,
    //     data = {
    //       datasetId: datasetId,
    //       modelType: this.modelType,
    //     }

    //   return new Promise((resolve, reject) => {
    //     PRETRAIN.getLabelByDatasetId(data).then((result) => {
    //       if (result.isSuccess) {
    //         this.Label = result
    //         this.Label.records = result.data
    //         if (result.data.length) {
    //           this.activeLabel = result.data[0].labelId
    //         }

    //         resolve(result.data)
    //       } else {
    //         reject(result)
    //       }
    //     })
    //   })
    // },
    // // 检测标题命名值
    // checkLabelValue(value) {
    //   var result = false
    //   // eslint-disable-next-line no-useless-escape
    //   if (!/^[\u4e00-\u9fa5\_A-Za-z0-9]+$/.test(value)) {
    //     this.$message({
    //       message: '标签名称只能由汉字、字母、数字组成',
    //       type: 'error',
    //       duration: 2000,
    //     })
    //     result = true
    //   }
    //   return result
    // },
    // /**
    //  * 创建标签 分类标签  @data  "datasetId"数据集id labelName标签名称
    //  */
    // addLabel() {
    //   var datasetId = this.activeDataset,
    //     labelName = this.popupData.labelName,
    //     data = {
    //       labelName: labelName,
    //       datasetId: datasetId,
    //     }

    //   // 标签命名检测，只能由汉字、字母、数字组成
    //   if (this.checkLabelValue(labelName)) {
    //     return
    //   }

    //   PRETRAIN.addLabel(data).then((result) => {
    //     if (result.isSuccess) {
    //       this.$message.success(result.returnMsg);
    //       this.cancelPopup(); // 关闭弹窗
    //       if (!this.Label.records) {
    //         this.Label.records = [];
    //       }

    //       this.getLabelList(); // 获取标签列表
    //       this.popupData.labelName = '';
    //       // TODO: tip
    //     } else {
    //       this.$message.error(result.returnMsg);
    //     }
    //   })
    // },
    // // 删除标签
    // activeLabelDeletePopup(labelId, datasetId, index) {
    //   this.popupActive = 'label_delete'
    //   this.popupData.labelDelete = {
    //     labelId: labelId,
    //     datasetId: datasetId,
    //     index: index,
    //   }
    // },
    // deleteLabel(labelId, datasetId, index) {
    //   var label = this.Label.records[index],
    //     labelName = label.labelName,
    //     data = {
    //       labelName: labelName,
    //       labelId: labelId,
    //       datasetId: datasetId,
    //       datasetType: this.modelType,
    //     };
    //   // 如果已激活的标签，需要删除激活
    //   if (labelId === this.activeLabel) {
    //     this.activeLabel = ''
    //   }
    //   PRETRAIN.deleteLabelBylabelId(data).then((result) => {
    //     if (result.isSuccess) {
    //       this.$message.success('已删除标签：' + labelName);
    //       this.Label.records.splice(index, 1);
    //       this.Label.total -= 1;
    //       this.getLabelList(); // 获取标签列表
    //       // 初始化处理
    //       if (this.Label.records && this.Label.records.length > 0) {
    //         this.activeLabel = this.Label.records[0].labelId;
    //       } else {
    //         this.Pictures.records = null;
    //         this.Pictures.total = 0;
    //       }
    //     } else {
    //       this.$message.error(result.returnMsg);
    //     }
    //   })
    // },
    // // 数据集音频处理  根据标签id查询音频列表
    // // tips:音频分类中，需要数据集和分类标签完备情况下使用
    // getPictureList(current) {
    //   var pageIndex_ = current ? current : 1,
    //     pageSize = this.Pictures.size,
    //     data = {};

    //   // 分类里面数据和标签分类同时存在才能获取
    //   if (!this.activeDataset || !this.activeLabel) {
    //     return
    //   }

    //   data = {
    //     datasetId: this.activeDataset,
    //     labelId: this.activeLabel,
    //     pageNum: pageIndex_,
    //     pageSize: pageSize,
    //     // isQualified: this.selectCondition,
    //   }

    //   // if (this.activeTag) {
    //   // data.isTag = 1;
    //   //   debugger;
    //   // }
    //   // 依据数据集id 和标签id请求音频列表
    //   return PRETRAIN.getAudioByLabelId(data).then((result) => {
    //     if (result.isSuccess) {
    //       this.Pictures = result.data;
    //       this.Pictures.records.forEach(item => {
    //         // if (item.isQualified == 0) {
    //         //   item.checked = true;
    //         // } else {
    //         //   item.checked = false;
    //         // }
    //       });
    //       // 当前页没有音频回调去到上一页
    //       if (this.Pictures && this.Pictures.current > 1 && this.Pictures.records.length === 0) {
    //         let currentPageNum = this.Pictures.current - 1;
    //         this.getPictureList(currentPageNum);
    //       }
    //     }
    //     return result;
    //   })
    // },
    // // 激活标签选中
    // activeCatetoryLabel(labelId /*, index*/) {
    //   this.activeLabel = labelId;
    // },
    // // 关闭弹窗
    // cancelPopup() {
    //   this.popupActive = '';
    //   // TODO: popupData 考虑是否要清除
    // },
    // // 删除
    // activeDeletePopup(imgId, index) {
    //   this.popupActive = 'delete';
    //   this.popupData.delete.index = index;
    // },
    // // 删除操作
    // deleteOperate() {
    //   if (this.popupActive === 'delete') { // 删除音频操作
    //     this.deletePicture();
    //   } else if (this.popupActive === 'label_delete') { // 删除标签操作
    //     let labelDelete = this.popupData.labelDelete,
    //       labelId = labelDelete.labelId,
    //       datasetId = labelDelete.datasetId,
    //       index = labelDelete.index;

    //     this.deleteLabel(labelId, datasetId, index);
    //   }

    //   // 关闭弹窗
    //   this.cancelPopup();
    // },
    // // 删除音频
    // deletePicture() {
    //   // TODO:删除音频
    //   var deleteIndex = this.popupData.delete.index,
    //     audio = this.Pictures.records[deleteIndex],
    //     data = {
    //       audioId: audio.audioId,
    //       audioName: audio.audioName,
    //     };

    //   PRETRAIN.deleteAudioByAudioId(data).then((result) => {
    //     if (result.isSuccess) {
    //       this.$message.success('已删除音频：' + audio.audioName);
    //       this.getPictureList(this.Pictures.current);
    //     } else {
    //       this.$message.error(result.returnMsg);
    //     }
    //   })
    // },
    // // 标签重命名
    // activeRenameLabelPopup(labelName, labelId, index) {
    //   this.popupActive = "rename";
    //   this.popupData.rename.index = index;
    //   this.popupData.rename.value = labelName;
    //   this.popupData.rename.flag = "label";
    // },
    // // TODO:确认标签重命名
    // renameLabel() {
    //   // if (!this.popupData.rename.value) {
    //   //   return this.$message.error('重命名不能为空！')
    //   // }
    //   // 标签命名检测，只能由汉字、字母、数字组成
    //   if (this.checkLabelValue(this.popupData.rename.value)) {
    //     return
    //   }
    //   var index = this.popupData.rename.index,
    //     labelName = this.popupData.rename.value,
    //     label = this.Label.records[index],
    //     labelId = label.labelId,
    //     datasetId = label.datasetId,
    //     data = {};

    //   data = {
    //     labelName: labelName,
    //     labelId: labelId,
    //     datasetId: datasetId
    //   };

    //   PRETRAIN.updateLabelBylabelId(data).then(result => {
    //     if (result.isSuccess) {
    //       let iLabel = this.Label;
    //       iLabel.records[index].labelName = labelName;
    //       this.Label = iLabel;
    //       this.cancelPopup();
    //       this.$message.success(result.returnMsg);
    //     }else {
    //       this.$message.error(result.returnMsg);
    //     }
    //   });
    // },
    // // 确认重命名
    // renameOperate() {
    //   // 在弹窗数据中，存放 flag
    //   if (this.popupData.rename.flag === "label") {
    //     this.renameLabel(); // 确认标签重命名
    //   } else if (this.popupData.rename.flag === "picture") {
    //     this.renamePicture(); // 确认音频重命名
    //   }
    // },
    // // 音频重命名
    // activeRenamePopup(obj, index) {
    //   this.popupActive = 'rename';
    //   this.popupData.rename.index = index;
    //   this.popupData.rename.audioId = obj.audioId;
    //   // this.popupData.rename.audioName = obj.audioName;
    //   this.popupData.rename.value = obj.audioName;
    //   this.popupData.rename.flag = 'picture';
    // },
    // // TODO:确认音频重命名
    // renamePicture() {
    //   if (!this.popupData.rename.value) {
    //     return this.$message.error('重命名不能为空！');
    //   }
    //   if (this.popupData.rename.value.length > 20) {
    //     return this.$message.error('重命名不能超过20个字符！');
    //   }
    //   var renameIndex = this.popupData.rename.index,
    //     audioName = this.popupData.rename.value,
    //     audioId = this.popupData.rename.audioId,
    //     data = {
    //       audioId: audioId,
    //       audioName: audioName,
    //     },
    //     list = [];

    //   PRETRAIN.updateAudioByAudioId(data).then((result) => {
    //     if (result.isSuccess) {
    //       this.$message.success(result.returnMsg);
    //       list = JSON.parse(JSON.stringify(this.Pictures.records));
    //       list[renameIndex].audioName = audioName;
    //       this.Pictures.records = list;
    //       this.cancelPopup(); // 关闭弹窗
    //     } else {
    //       this.$message.error(result.returnMsg);
    //     }
    //   })
    // },
    
    // // 引用数据集
    // quoteDataset() {
    //   this.drawerShow = true // 打开数据集弹窗
    // },
    // // 音频上传
    // uploadPictures() {
    //   if (this.Pictures.total >= 200) {
    //     return this.$message.error('单个分类标签的音频总数不超过200个哦~');
    //   }
    //   // TODO: 数据集选定、分类标签选定
    //   if (!this.popupData.uploadNoTip) {
    //     this.activeUploadTipPopup();
    //   } else {
    //     // 直接上传
    //     this.uploadPicturesToDataset();
    //   }
    // },
    // // 上传音频到相应标签的数据集中
    // uploadPicturesToDataset() {
    //   var uploadFileNode = document.createElement('input'), // 创建上传按钮
    //     fileList = [], // 文件列表
    //     self = this;

    //   uploadFileNode.setAttribute('type', 'file'); // 设置上传按钮属性
    //   uploadFileNode.setAttribute('multiple', 'ture'); // 多文件上传
    //   uploadFileNode.setAttribute('accept', '.mp3, .wav'); // 限制.mp3|.wav音频除外的文件上传
    //   // uploadFileNode.setAttribute("enctype", "multipart/form-data;"); // 编码方式

    //   uploadFileNode.click(); // 触发上传事件

    //   // 上传进程
    //   uploadFileNode.onchange = function uploadChange(evt) {
    //     var formdata = new FormData(),
    //       formatPass = true,
    //       list;

    //     // 文件装配
    //     fileList = evt.target.files;
    //     list = Array.from(fileList);

    //     if (list.length > 200) {
    //       return self.$message.error('上传失败，单次上传音频限制200个!');
    //     }

    //     if (self.Pictures.total + list.length > 200) {
    //       return self.$message.error('上传失败，单个分类标签的音频总数不超过200个哦~');
    //     }

    //     // formatPass = self.$util.filesFormatCheck(list, 'mp3|MP3|wav|WAV');
    //     // if (formatPass) {
    //     //   return self.$message.error('上传失败，请上传格式为 wav/mp3 的音频！');
    //     // }
        
    //     let noFile = 0
    //     list.forEach( async (file) => {
    //       let typeFlag = self.$util.filesFormatCheck(file, 'mp3|MP3|wav|WAV');
    //       if (typeFlag) {
    //         noFile++;
    //         self.$message.error(`${file.name}上传失败，请上传格式为 wav/mp3 的音频！`);
    //       } else if (file.size > 5242880) {
    //         noFile++
    //         self.$message.error(`上传失败，音频名称为${file.name}格式过大！`);
    //       } else {
    //         // formdata.append('uploadFiles', file)
    //         formdata.append('file', file);
    //       }
    //     })
    //     if (list.length === noFile) {
    //       return
    //     }

    //     self.fullscreenLoading = self.$loading({
    //       lock: true,
    //       text: '音频上传中请稍等...',
    //       spinner: 'el-icon-loading',
    //       background: 'rgba(0, 0, 0, 0.7)'
    //     });
    //     // console.log(formdata)

    //     setTimeout(() => {
    //       COMMON.UploadMultipleFile(formdata).then((result) => {
    //         var data = {
    //           datasetId: self.activeDataset,
    //           labelId: self.activeLabel,
    //         }

    //         if (result.returnCode === 200) {
    //           let datasetAudioList = result.data.map((item) => {
    //             return {
    //               audioUrl: item.url,
    //               audioName: item.fileName,
    //             }
    //           })
    //           data.datasetAudioList = datasetAudioList;
    //           // 上传到服务器的文件转存到数据库中;
    //           PRETRAIN.uploadAudio(data).then((result) => {
    //             if (result.isSuccess) {
    //               // 上传成功
    //               self.$message.success(result.returnMsg);
    //               // TODO:刷新音频数据
    //               self.getPictureList();
    //               uploadFileNode = null; // 移除上传控件
    //               self.fullscreenLoading.close(); // 关闭Loading
    //             } else {
    //               self.$message.error(result.returnMsg);
    //               self.fullscreenLoading.close(); // 关闭Loading
    //             }
    //           }).catch((error)=>{
    //             self.fullscreenLoading.close(); // 关闭Loading
    //           });
    //         } else {
    //           self.$message.error(result.returnMsg);
    //           self.fullscreenLoading.close(); // 关闭Loading
    //         }
    //       }).catch((error)=>{
    //         self.fullscreenLoading.close(); // 关闭Loading
    //       });
    //     }, 100);
    //   }

    //   uploadFileNode.onprogress = function uploadProgress(evt) {
    //     console.log(evt);
    //   }
    // },
    // // 音频上传说明
    // activeUploadTipPopup() {
    //   this.popupActive = 'uploadtip';
    // },
    // // 上传提示显示后再进行上传操作
    // confirmUploadTip() {
    //   // 音频上传说明确认
    //   this.cancelPopup();
    //   // TODO:上传音频事件触发
    //   this.uploadPicturesToDataset();
    // },
    // // 上传音频
    // uploadNoTipChange(val) {
    //   this.localStorageUploadTip('save', val);
    // },
    // // 音频上传说明是否显示存储
    // localStorageUploadTip(type, value) {
    //   if (type === 'save') {
    //     // TODO:
    //     this.popupData.uploadNoTip = value;
    //     window.localStorage.setItem('__upload_audioCategorization_tip__', value);
    //   } else {
    //     let uploadNoTip = window.localStorage.getItem('__upload_audioCategorization_tip__');
    //     this.popupData.uploadNoTip = uploadNoTip ? uploadNoTip : false;
    //   }
    // },
    // // 音频翻页
    // handleCurrentChange(current) {
    //   this.getPictureList(current);
    // },
    // // 添加标签 -- 最多能创建 15 个标签分类
    // activeAddTagPopup() {
    //   this.popupData.labelName = '';
    //   if (!this.activeDataset) {
    //     return this.$message.warning('请选择数据集再进行标签操作');
    //   }
    //   this.popupActive = 'add_tag';
    // },
  },
}
</script>

<style lang="scss" scoped>
// @import './pretrain_common.scss';
// @import './DatasetAudioCategorization.scss';
</style>
